module.exports = __webpack_public_path__ + "static/join-button.9f7858e1.png";